<script setup lang="ts">
import { copyToClipboard } from '@/utils'
import { List } from 'lucide-vue-next'
import { AplosFile } from '../models/AplosFile';

const props = defineProps<{
  record: AplosFile
  index?: number
  selectable?: boolean
  onCellClick?: (record: any, e?: Event) => void
}>()

function handleClick(e?: Event) {
  if (props.selectable && props.onCellClick) {
    props.onCellClick(props.record, e)
  }
}

function handleCopy(e?: Event) {
  e?.stopPropagation()
  copyToClipboard(props.record?.id || '')
}
</script>

<template>
  <div class="flex" :class="{ 'cursor-pointer': selectable }" @click="handleClick">
    <a-tooltip>
      <template #title>{{ record.id }}</template>
      <List @click="handleCopy" class="size-5" />
    </a-tooltip>
  </div>
</template>
